Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.ClipboardTransferMode = module.exports.default = {
	CLONE_ONLY: "cloneOnly",
	CLONE_PREFERRED: "clonePreferred",
	ORIGINAL_ONLY: "originalOnly",
	ORIGINAL_PREFERRED: "originalPreferred"
};